import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { ModalLoginComponent } from '../modal-login/modal-login.component';
import { ModalRegisterComponent } from '../modal-register/modal-register.component';





@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  collapsed = true;
  modalOptions:NgbModalOptions;
  ruta = '';
  constructor(
    private modalService: NgbModal,
    //private router: Router
  ) {
   
   }

  ngOnInit(): void {
    //this.ruta = (this.router.url.split('?')[0]).split('/')[2];
  }

  openLogin() {    
    const modalRef = this.modalService.open(ModalLoginComponent, { 
      centered: true,  
      backdrop:'static' 
    });       
  }

  openRegister() {    
    const modalRef = this.modalService.open(ModalRegisterComponent, { 
      centered: true,  
      backdrop:'static' 
    });  
    modalRef.componentInstance.padre = 'header';      
  }

}
